import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { AppComponent } from '@app/app.component';
import { environment } from '@env/environment';

if (environment.csp) {
  const meta = document.createElement('meta');
  meta.httpEquiv = 'Content-Security-Policy';
  meta.content = environment.csp;
  document.head.prepend(meta);
}
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
